import { pipe, trim, map, filter, identity, join } from 'ramda'

/**
 * Конвертирует объект с данными адреса в строку
 */
export type Address = {
  town?: string | null
  street?: string | null
  house?: string | null
  corp?: string | null
  apart?: string | null
}

export const getAddressString = ({ town, street, house, corp, apart }: Address): string => {
  const arr = [town, street, house, corp, apart].map((item) => (item ? item.trim() : ''))
  if (!arr.join()) return ''
  if (arr[1] && arr[1].search(/ул./i)) arr[1] = `ул. ${arr[1]}`
  if (arr[2]) arr[2] = arr[2].search(/д./i) ? `д.${arr[2]}` : arr[2]
  if (arr[3] && arr[3].search(/кв./i)) arr[3] = `корп.${arr[3]}`
  if (arr[4] && arr[4].search(/кв./i)) arr[4] = `кв.${arr[4]}`
  return arr.filter((a) => a).join(', ')
}

/**
 * Создает строку с аргументами функции через запятую
 */
export const commaJoin = (...args): string =>
  pipe(filter<any>(identity), map(trim), join(', '))(args) as string
